import { useState } from 'react';
import { COUNTRIES, CURRENCIES } from '../../mock';

export default function Coverage() {
  const [tab, setTab] = useState('countries');
  const list = tab === 'countries' ? COUNTRIES : CURRENCIES;

  return (
    <section className="py-20 lg:py-28 bg-[#EFE9D8]">
      <div className="max-w-[1400px] mx-auto px-6 lg:px-10">
        <div className="grid lg:grid-cols-12 gap-10 items-end">
          <div className="lg:col-span-7">
            <p className="text-[11px] uppercase tracking-[0.25em] text-[#0B3B2E]/70 font-medium reveal">
              Global coverage
            </p>
            <h2 className="mt-4 font-serif text-[40px] lg:text-[56px] leading-[1.05] text-[#0B3B2E] reveal">
              135 countries. <span className="italic">48 currencies.</span> One account.
            </h2>
          </div>
          <div className="lg:col-span-5 flex lg:justify-end">
            <div className="inline-flex p-1 rounded-full bg-[#0B3B2E]/8">
              {['countries', 'currencies'].map((k) => (
                <button
                  key={k}
                  type="button"
                  onClick={() => setTab(k)}
                  aria-pressed={tab === k}
                  className={`px-5 h-10 rounded-full text-[13px] font-medium capitalize transition-all duration-300 ${
                    tab === k
                      ? 'bg-[#0B3B2E] text-[#F5F1E8]'
                      : 'text-[#0B3B2E] hover:text-[#0B3B2E]/70'
                  }`}
                >
                  {k}
                </button>
              ))}
            </div>
          </div>
        </div>

        {/*
          NOTE: Do NOT add the 'reveal' class to these items. The IntersectionObserver
          only runs once on mount; items rendered later (after a tab switch) never get
          .is-visible added, so they stay invisible — which is what caused the
          "currencies tab does nothing" bug. Rendering them plainly fixes it.
        */}
        <div key={tab} className="mt-12 grid grid-cols-2 sm:grid-cols-3 lg:grid-cols-4 gap-3">
          {list.map((item) => (
            <div
              key={item.name}
              data-testid={`coverage-${tab}-item`}
              className="flex items-center gap-3 px-5 py-4 rounded-2xl bg-[#F5F1E8] border border-[#0B3B2E]/10 hover:border-[#0B3B2E]/40 hover:-translate-y-0.5 transition-all duration-300"
            >
              <span className="w-10 h-10 rounded-full bg-[#0B3B2E]/8 flex items-center justify-center font-serif text-[13px] font-semibold text-[#0B3B2E]">
                {(item.code || item.name).slice(0, 2).toUpperCase()}
              </span>
              <span className="text-[14px] font-medium text-[#0E1F1A]">{item.name}</span>
            </div>
          ))}
        </div>

        <p className="mt-8 text-center text-[13px] text-[#0E1F1A]/55 italic">and many more.</p>
      </div>
    </section>
  );
}
